import { get } from "../../api";
import { authHeader } from "../../utils";

const getOrderConfirmationDetails = orderId =>
  get("orderConfirm", authHeader(), orderId);

const getLoyaltyPointsData = orderId =>
  get("loyaltyPointsData", authHeader(), orderId);

export { getOrderConfirmationDetails, getLoyaltyPointsData };



// WEBPACK FOOTER //
// ./src/stores/OrderConfirmationStore/services.js